/* Moskin quick-add: "+" on PDP "Complete the look" cards and cart drawer upsell rows. */
(function () {
  if (window.mpxQA) return;
  window.mpxQA = true;

  var T = window.theme || {};
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var addUrl = function () { return ((T.routes && T.routes.cart_add_url) || root() + 'cart/add') + '.js'; };
  /* Manual "Complete the look" sets, they win over the rules. Each set: keys = cart product handles AND ids
     (ids survive /en handle translation), picks = ordered [handle, product_id] from /products/<handle>.js. */
  var MANUAL_SETS = {}; (function () {
    var add = function (keys, picks) { keys.forEach(function (k) { MANUAL_SETS[k] = picks; }); };
    // blue suits
    add(['kostium-dviika-synii-dvobortnyi', 8638727716952, 'synii-cholovichyi-odnobortnyi-kostium-dviika', 8629359706200, 'odnobortnyi-kostium-dviika-synii-u-klitku', 8629354102872, 'odnobortnyi-klasychnyi-kostium-temno-synoho-koloru', 8629368127576],
      [['sorochka-universalna-aivori-cholovicha-vodovidshchuiucha', 8647731085400], ['kravatka-cholovicha-shovkova-synia', 8806007701592], ['lofery-zamshevi-z-kytytsiamy-andreas-moskin', 8951113220184]]);
    // beige tuxedo
    add(['bezhevyi-smokinh-iz-shalevym-latskanom', 8556857000024],
      [['sorochka-pid-smoking-ta-metelyk-cholovicha', 8647768834136], ['metelyk-cholovichyi-shovkovyi-matovyi-bezhevo-korychnevyi', 8806006751320], ['chelsi-cholovichi-shkiriani-na-krosivkovii-pidoshvi-andreas-moskin', 8951111123032]]);
    // terracotta suit
    add(['terracotta-single-breasted-three-piece-suit', 8532685848664],
      [['sorochka-cholovicha-iz-bavovny', 8647613448280], ['kravatka-cholovicha-shovkova-v-smuzhku-korychneva', 8806007144536], ['derbi-choloviche-shkiriani-andreas-moskin', 8951110828120]]);
    // women grey suits
    add(['zhinochyi-siryi-kostium-drapovanyi-zhaket-vilni-shtany', 8913078157400, 'zhinochyi-siryi-kostium-atlasnyi-latskan-shtany-klesh', 8913078091864, 'zhinochyi-siryi-kostium-klasychnyi-zhaket-priami-shtany', 8913078026328],
      [['zhinochyi-chornyi-korset-z-prozoroiu-vstavkoiu', 8677460443224], ['zhinochyi-klatch-siryi', 8911977054296]]);
  })();

  var str = function (el, key) {
    var h = el && el.closest('[data-' + key + ']');
    return (h && h.getAttribute('data-' + key)) || '';
  };

  function addVariant(id) {
    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(typeof j.description === 'string' ? j.description : (j.message || ''));
        return j;
      });
    });
  }

  // Same signals the theme uses after an add: refresh the cart items, then open the drawer.
  function afterAdd() {
    if (T.settings && T.settings.cartType === 'page') {
      window.location = T.routes.cart_url;
      return;
    }
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
  }

  function say(item, text, ms) {
    var msg = item.querySelector('[data-mpx-msg]');
    if (!msg) return;
    msg.textContent = text;
    clearTimeout(item._mpxT);
    item._mpxT = setTimeout(function () { msg.textContent = ''; }, ms);
  }

  function variantsOf(item) {
    if (item._mpxV) return item._mpxV;
    var s = item.querySelector('script[data-mpx-variants]');
    try { item._mpxV = JSON.parse(s.textContent); } catch (e) { item._mpxV = []; }
    return item._mpxV;
  }

  function doAdd(item, id, busyEl) {
    if (busyEl) busyEl.setAttribute('aria-busy', 'true');
    return addVariant(id).then(function () {
      closeSizes(item);
      say(item, str(item, 'added'), 2000);
      afterAdd();
    }).catch(function (e) {
      say(item, (e && e.message) || str(item, 'error'), 4000);
    }).then(function () {
      if (busyEl) busyEl.removeAttribute('aria-busy');
    });
  }

  function closeSizes(item) {
    var box = item.querySelector('[data-mpx-sizes]');
    var btn = item.querySelector('[data-mpx-qa]');
    if (box) box.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  // One chip per unique size. Variant per size: same non-size options as the featured
  // (first available) variant; else any available variant of that size; disabled if none.
  function sizeChips(vs) {
    var si = vs.length && typeof vs[0].s === 'number' ? vs[0].s : -1;
    if (si < 0 || !vs[0].o) {
      return vs.map(function (v) { return { id: v.id, title: v.title, disabled: !v.available }; });
    }
    var cur = vs.filter(function (v) { return v.f && v.available; })[0] || vs.filter(function (v) { return v.available; })[0];
    var order = [];
    var by = {};
    vs.forEach(function (v) {
      var k = v.o[si];
      if (!by[k]) { by[k] = []; order.push(k); }
      by[k].push(v);
    });
    return order.map(function (k) {
      var list = by[k];
      var pick = cur && list.filter(function (v) {
        return v.available && v.o.every(function (x, i) { return i === si || x === cur.o[i]; });
      })[0] || list.filter(function (v) { return v.available; })[0];
      return { id: (pick || list[0]).id, title: k, disabled: !pick };
    });
  }

  function onPlus(btn) {
    var item = btn.closest('[data-mpx-item]');
    var vs = variantsOf(item);
    var avail = vs.filter(function (v) { return v.available; });
    if (!avail.length) { say(item, str(item, 'error'), 3000); return; }
    if (vs.length === 1 || avail.length === 1) { doAdd(item, avail[0].id, btn); return; }
    var box = item.querySelector('[data-mpx-sizes]');
    if (!box.children.length) {
      sizeChips(vs).forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mpx__size';
        b.textContent = c.title;
        b.setAttribute('data-variant', c.id);
        if (c.disabled) b.disabled = true;
        box.appendChild(b);
      });
    }
    box.hidden = !box.hidden;
    btn.setAttribute('aria-expanded', String(!box.hidden));
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-mpx-qa]');
    if (plus) { e.preventDefault(); onPlus(plus); return; }
    var size = e.target.closest && e.target.closest('.mpx__size');
    if (size && !size.disabled) {
      e.preventDefault();
      doAdd(size.closest('[data-mpx-item]'), Number(size.getAttribute('data-variant')), size);
    }
  });

  /* ---------- cart drawer upsell: "Complete the look" ---------- */
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var imgUrl = function (p) {
    var u = p.featured_image;
    if (u && typeof u === 'object') u = u.url || u.src;
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  };
  var money = function (c) { return T.formatMoney ? T.formatMoney(c, T.moneyWithCurrencyFormat || T.moneyFormat) : (c / 100).toFixed(2); };

  function row(p) {
    var si = (p.options || []).map(function (o) { return String((o && o.name) || o).toLowerCase(); })
      .findIndex(function (n) { return /розмір|size|размер/.test(n); });
    var vs = (p.variants || []).map(function (v) {
      return {
        id: v.id,
        title: si > -1 && v['option' + (si + 1)] ? v['option' + (si + 1)] : v.title,
        available: !!v.available,
        o: [v.option1 || null, v.option2 || null, v.option3 || null],
        s: si,
        f: false
      };
    });
    var firstAv = vs.filter(function (v) { return v.available; })[0];
    if (firstAv) firstAv.f = true;
    if (!vs.some(function (v) { return v.available; })) return '';
    var img = imgUrl(p);
    return '<div class="mpx-cu__row" data-mpx-item>' +
      '<a class="mpx-cu__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="64" height="86" loading="lazy">' : '') + '</a>' +
      '<a class="mpx-cu__info" href="' + esc(p.url) + '"><span class="mpx-cu__name">' + esc(p.title) + '</span><span class="mpx-cu__price">' + money(p.price) + '</span></a>' +
      '<button type="button" class="mpx__qa mpx-cu__qa" data-mpx-qa aria-label="' + esc(plusLabel + ': ' + p.title) + '"><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.2" fill="none"/></svg></button>' +
      '<div class="mpx__sizes mpx-cu__sizes" data-mpx-sizes role="group" hidden></div>' +
      '<p class="mpx__msg mpx-cu__msg" data-mpx-msg role="status" aria-live="polite"></p>' +
      '<script type="application/json" data-mpx-variants>' + JSON.stringify(vs).replace(/</g, '\\u003c') + '<\/script>' +
      '</div>';
  }

  var plusLabel = '';
  var token = 0;
  var lastSig = null;

  /* ---- "Complete the look" picker: category + gender + colour rules, candidates from existing collections ---- */
  var TUX_SHIRT = 'sorochka-pid-smoking-ta-metelyk-cholovicha';
  var TUX_ID = 8647768834136;
  var TYPE_CAT = {
    'suits': 'suit', "men's linen suit": 'suit', 'tuxedos': 'tuxedo', 'blazers': 'blazer',
    'trousers': 'trousers', 'jeans': 'trousers', 'athletic pants': 'trousers',
    'shirts': 'shirt', 'polo shirts': 'polo', 'turtlenecks': 'polo', 'jumpers': 'polo', 't-shirts': 'polo', 'hoodies': 'polo',
    'coats': 'outerwear', 'jackets': 'outerwear', 'trench coats': 'outerwear', 'vests': 'vest',
    'footwear': 'shoes', 'sneakers': 'shoes', 'ties': 'tie', 'bow ties': 'bowtie', 'handkerchiefs': 'handkerchief',
    'accessories': 'accessory'
  };
  var WTYPE_CAT = {
    "women's suits": 'wsuit', "women's linen suit": 'wsuit', "women's jackets": 'wjacket',
    "women's blazer dress": 'wdress', "women's dresses": 'wdress', 'jumpsuits': 'wdress',
    "women's trousers": 'wtrousers', 'skirts': 'wskirt', "women's outerwear": 'wcoat',
    "women's top": 'wtop', "women's corsets": 'wcorset', 'clutches': 'clutch'
  };
  // Complement map, in priority order.
  var COMP = {
    suit: ['shirt', 'tie', 'shoes', 'handkerchief'],
    tuxedo: ['shirt', 'bowtie', 'shoes', 'handkerchief'],
    blazer: ['trousers', 'shirt', 'polo', 'shoes'],
    trousers: ['shirt', 'polo', 'blazer', 'shoes'],
    shirt: ['tie', 'bowtie', 'handkerchief', 'trousers'],
    polo: ['trousers', 'outerwear', 'shoes'],
    outerwear: ['scarf', 'polo', 'trousers', 'shoes'],
    vest: ['shirt', 'tie', 'trousers'],
    shoes: ['trousers', 'shirt'],
    tie: ['shirt', 'handkerchief', 'accessory'],
    bowtie: ['shirt', 'handkerchief', 'accessory'],
    handkerchief: ['shirt', 'tie', 'bowtie'],
    scarf: ['shirt', 'polo', 'outerwear'],
    accessory: ['shirt', 'polo', 'outerwear'],
    wsuit: ['wtop', 'wcorset', 'clutch'],
    wjacket: ['wtop', 'wcorset', 'clutch', 'wtrousers', 'wskirt'],
    wtrousers: ['wjacket', 'wtop', 'clutch'],
    wskirt: ['wjacket', 'wtop', 'clutch'],
    wdress: ['clutch', 'wcoat'],
    wcoat: ['clutch', 'wdress'],
    wtop: ['wtrousers', 'wskirt', 'wjacket', 'clutch'],
    wcorset: ['wtrousers', 'wskirt', 'wjacket', 'clutch'],
    clutch: ['wdress', 'wjacket', 'wtrousers']
  };
  // Existing collections that hold each category (fetched lazily, cached in sessionStorage).
  var CAT_COL = {
    shirt: ['shirts'], tie: ['kravatki'], bowtie: ['meteliky'], handkerchief: ['khustynka'], shoes: ['shoes'],
    trousers: ['trousers'], polo: ['knitwear'], outerwear: ['outerwear'], vest: ['outerwear'],
    blazer: ['blazers'], tuxedo: ['blazers'], scarf: ['accessories'], accessory: ['accessories'],
    wsuit: ['zhinochyi-odiah'], wjacket: ['zhinochyi-odiah'], wtrousers: ['zhinochyi-odiah'], wskirt: ['zhinochyi-odiah'],
    wdress: ['zhinochyi-odiah'], wcoat: ['zhinochyi-odiah'], wtop: ['zhinochyi-odiah'], wcorset: ['zhinochyi-odiah'],
    clutch: ['zhinochi-aksesuary']
  };
  var RANK = ['tuxedo', 'suit', 'wsuit', 'wdress', 'blazer', 'wjacket', 'outerwear', 'wcoat', 'trousers', 'wtrousers', 'wskirt',
    'vest', 'polo', 'shirt', 'wtop', 'wcorset', 'shoes', 'clutch', 'tie', 'bowtie', 'handkerchief', 'scarf', 'accessory'];

  var lc = function (s) { return String(s == null ? '' : s).toLowerCase(); };
  var tagsOf = function (p) {
    var t = p.tags || [];
    if (typeof t === 'string') t = t.split(',');
    return t.map(function (x) { return lc(x).trim(); });
  };
  var isColorName = function (n) { return /колір|колор|color|colour/.test(lc(n)); };

  function genderOf(p) {
    var tg = tagsOf(p);
    var ty = lc(p.type || p.product_type);
    if (tg.indexOf('womens_clothing') > -1) return 'w';
    if (tg.indexOf('mens_clothing') > -1) return 'm';
    if (/^women's|^skirts$|^jumpsuits$|^clutches$/.test(ty)) return 'w';
    return '';
  }

  // Category of a product ('' when it must never be suggested or used as an anchor).
  function catOf(p) {
    var ty = lc(p.type || p.product_type);
    var tg = tagsOf(p);
    var h = lc(p.handle);
    var g = genderOf(p);
    if (!g || ty === 'gift' || /gift-card/.test(h) || /^chohol/.test(h)) return '';
    var has = function (t) { return tg.indexOf(t) > -1; };
    if (g === 'w') return WTYPE_CAT[ty] || (has('women_bags') ? 'clutch' : '');
    if (ty === 'tuxedos' || has('tuxedos')) return 'tuxedo';
    if (has('shoes')) return 'shoes';
    if (ty === 'ties' || has('necktie')) return 'tie';
    if (has('scarf')) return 'scarf';
    return TYPE_CAT[ty] || TYPE_CAT[ty + 's'] || (has('suits') ? 'suit' : '');
  }

  // Colour family from a Ukrainian or English colour name.
  function famOf(name) {
    var n = lc(name);
    if (!n) return '';
    if (/темно-?син|navy|dark blue/.test(n)) return 'navy';
    if (/голуб|блакит|light blue|sky/.test(n)) return 'lblue';
    if (/сіро-беж|капучін|капучин|cappuccino|taupe/.test(n)) return 'beige';
    if (/син|blue/.test(n)) return 'blue';
    if (/чорн|black/.test(n)) return 'black';
    if (/біл|white/.test(n)) return 'white';
    if (/айвор|ivory|молоч|cream/.test(n)) return 'ivory';
    if (/сір|grey|gray/.test(n)) return 'grey';
    if (/беж|beige|sand|пісоч/.test(n)) return 'beige';
    if (/коричн|brown|коньяк|cognac|карамел|caramel|теракот|terracotta/.test(n)) return 'brown';
    if (/зелен|green|хакі|khaki|олив|olive/.test(n)) return 'green';
    if (/бургунд|бордов|burgundy|червон|red|wine|винн/.test(n)) return 'burgundy';
    if (/жовт|yellow|гірчич|mustard/.test(n)) return 'warm';
    return '';
  }

  function famOfTags(p) {
    var tg = tagsOf(p);
    for (var i = 0; i < tg.length; i++) { var f = famOf(tg[i]); if (f) return f; }
    return '';
  }

  // Partner colour families for an anchor colour, in priority order.
  function prefs(f, cat, acat) {
    var dark = f === 'black' || f === 'navy' || f === 'blue' || f === 'grey' || f === 'green' || f === 'burgundy' || f === 'lblue';
    var pale = f === 'white' || f === 'ivory';
    if (cat === 'shoes') return f === 'black' ? ['black', 'brown'] : pale ? ['brown', 'beige', 'white'] : dark ? ['brown', 'black'] : ['brown', 'beige'];
    if (cat === 'shirt') return dark ? ['white', 'ivory', 'lblue', 'grey'] : pale ? ['white', 'ivory', 'lblue'] : ['white', 'ivory', 'lblue', 'beige'];
    if (acat === 'shirt' && pale) return ['black', 'navy', 'grey', 'blue', 'brown'];
    if (dark) return ['black', 'white', 'ivory', 'grey'];
    if (pale) return ['beige', 'brown', 'navy', 'ivory', 'white'];
    return ['brown', 'beige', 'ivory', 'white'];
  }

  function score(c, a, cat) {
    var s = 0;
    var i = a.fam ? prefs(a.fam, cat, a.cat).indexOf(c.fam) : -1;
    if (i > -1) s += 20 - i * 4;
    if (cat === 'shirt') {
      var classic = c.tags.indexOf('classic_shirts') > -1;
      var light = c.fam === 'white' || c.fam === 'ivory';
      if (a.cat === 'tuxedo') s += ((c.handle === TUX_SHIRT || c.id === TUX_ID) ? 100 : 0) + (classic && light ? 30 : 0);
      else s += (classic ? 8 : 0) - ((c.handle === TUX_SHIRT || c.id === TUX_ID) ? 15 : 0);
    }
    if (a.cat === 'polo' && lc(c.type) === 'jeans') s += 2;
    return s;
  }

  // Ordered, de-duplicated categories to look for, each remembering the anchor that asked for it.
  function wantList(anchors, skipCats) {
    var inCart = {};
    anchors.forEach(function (a) { inCart[a.cat] = true; });
    if (inCart.suit || inCart.tuxedo) inCart.blazer = true;
    if (inCart.wsuit) { inCart.wjacket = true; inCart.wtrousers = true; inCart.wskirt = true; }
    var hasTux = !!inCart.tuxedo;
    var seen = {};
    (skipCats || []).forEach(function (c) { seen[c] = true; });
    var out = [];
    anchors.slice().sort(function (x, y) { return RANK.indexOf(x.cat) - RANK.indexOf(y.cat); }).forEach(function (a) {
      (COMP[a.cat] || []).forEach(function (c) {
        if (seen[c] || inCart[c]) return;
        if (c === 'bowtie' && a.cat === 'shirt' && !(a.formal || hasTux)) return;
        seen[c] = true;
        out.push({ cat: c, a: a });
      });
    });
    return out;
  }

  function bestOf(pool, want, taken) {
    var best = null;
    var top = -1;
    pool.forEach(function (c) {
      if (c.cat !== want.cat || c.gender !== want.a.gender || !c.available || taken[c.id]) return;
      var s = score(c, want.a, want.cat);
      if (s > top) { top = s; best = c; }
    });
    return best;
  }

  /* ---- data: cart anchors + candidate pools ---- */
  function normProduct(p) {
    var money100 = function (x) { return typeof x === 'string' ? Math.round(parseFloat(x) * 100) : x; };
    var opts = (p.options || []).map(function (o) { return (o && o.name) || o; });
    var vs = (p.variants || []).map(function (v) {
      return { id: v.id, available: !!v.available, option1: v.option1 || null, option2: v.option2 || null, option3: v.option3 || null, price: money100(v.price) };
    });
    var av = vs.filter(function (v) { return v.available; });
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || img.url || '';
    var ci = opts.findIndex(isColorName);
    var cv = av[0] && ci > -1 ? av[0]['option' + (ci + 1)] : '';
    var out = {
      id: p.id, handle: p.handle, title: p.title, type: p.type || p.product_type || '', tags: tagsOf(p),
      options: opts, variants: vs, available: av.length > 0,
      price: av.length ? Math.min.apply(null, av.map(function (v) { return v.price; })) : (vs[0] ? vs[0].price : 0),
      featured_image: img, url: root() + 'products/' + p.handle
    };
    out.gender = genderOf(out);
    out.cat = catOf(out);
    out.fam = famOf(cv) || famOfTags(out);
    return out;
  }

  var memo = {};
  var store = function (k, v) {
    try {
      if (v === undefined) { var raw = sessionStorage.getItem(k); var o = raw && JSON.parse(raw); return o && Date.now() - o.t < 600000 ? o.v : null; }
      sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), v: v }));
    } catch (e) {}
    return null;
  };

  function getJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function loadCollection(handle) {
    var key = 'mpx:col:' + root() + handle;
    if (memo[key]) return memo[key];
    var cached = store(key);
    if (cached) return (memo[key] = Promise.resolve(cached));
    return (memo[key] = getJson(root() + 'collections/' + handle + '/products.json?limit=250').then(function (j) {
      var list = ((j && j.products) || []).map(normProduct).filter(function (p) { return p.cat; });
      if (list.length) store(key, list);
      return list;
    }));
  }

  // Cart lines only carry product_type; tags come from /products/<handle>.js.
  function anchorOf(item) {
    var key = 'mpx:prd:' + root() + item.handle;
    var done = function (full) {
      var p = full ? normProduct(full) : { id: item.product_id, handle: item.handle, type: item.product_type, tags: [/^women's|^skirts$|^jumpsuits$|^clutches$/.test(lc(item.product_type)) ? 'womens_clothing' : 'mens_clothing'], variants: [], options: [] };
      var cat = catOf(p);
      if (!cat) return null;
      var cv = '';
      (item.options_with_values || []).forEach(function (o) { if (isColorName(o.name)) cv = o.value; });
      return {
        cat: cat, gender: genderOf(p), id: item.product_id, handle: item.handle,
        fam: famOf(cv) || p.fam || famOfTags(p),
        formal: p.tags.indexOf('classic_shirts') > -1 || (item.handle === TUX_SHIRT || item.product_id === TUX_ID)
      };
    };
    if (memo[key]) return memo[key].then(done);
    var cached = store(key);
    var load = cached ? Promise.resolve(cached) : getJson(root() + 'products/' + item.handle + '.js').then(function (j) { if (j) store(key, j); return j; });
    memo[key] = load;
    return load.then(done);
  }

  // Raw /products/<handle>.js, same cache key as anchorOf. Handles are UA; the .js endpoint 404s under /en/, so fall back to the root.
  function rawProduct(handle) {
    var key = 'mpx:prd:' + root() + handle;
    if (memo[key]) return memo[key];
    var cached = store(key);
    if (cached) return (memo[key] = Promise.resolve(cached));
    return (memo[key] = getJson(root() + 'products/' + handle + '.js')
      .then(function (j) {
        if (j || root() === '/') return j;
        // translated handle: follow the 301 of the HTML URL, then read its .js; else UA data
        return fetch(root() + 'products/' + handle, { method: 'HEAD', credentials: 'same-origin' })
          .then(function (r) { var u = r.url.split('?')[0]; return u.indexOf('/products/' + handle) === -1 ? getJson(u + '.js') : null; })
          .catch(function () { return null; })
          .then(function (t) { return t || getJson('/products/' + handle + '.js'); });
      })
      .then(function (j) { if (j) store(key, j); return j; }));
  }

  // Admin set from product.metafields.moskin.complete_look via templates/product.mpxcl.liquid: [[handle, id], ...] or [].
  function metaSet(handle) {
    var key = 'mpx:cl:' + root() + handle;
    if (memo[key]) return memo[key];
    var cached = store(key);
    if (cached) return (memo[key] = Promise.resolve(cached));
    var get = function (base) {
      return fetch(base + 'products/' + handle + '?view=mpxcl', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { try { var j = t && JSON.parse(t); return Array.isArray(j) ? j : null; } catch (e) { return null; } })
        .catch(function () { return null; });
    };
    return (memo[key] = get(root())
      .then(function (j) { return j || root() === '/' ? j : get('/'); })
      .then(function (j) { j = j || []; store(key, j); return j; }));
  }

  // Manual picks for the cart anchors, in cart order, then pick order; at most 3 distinct, available, not in cart.
  // Per anchor: Admin metafield set first, else the MANUAL_SETS fallback.
  function manualPicks(anchors, taken) {
    var order = [];
    var seenId = {};
    var chain = Promise.all(anchors.map(function (a) { return metaSet(a.handle); })).then(function (metas) {
      anchors.forEach(function (a, i) {
        var set = metas[i] && metas[i].length ? metas[i] : (MANUAL_SETS[a.id] || MANUAL_SETS[a.handle] || []);
        set.forEach(function (pk) {
          if (!seenId[pk[1]]) { seenId[pk[1]] = true; order.push(pk); }
        });
      });
    });
    var out = [];
    return chain.then(function () {
      var seq = Promise.resolve();
      order.forEach(function (pk) {
        seq = seq.then(function () {
          if (out.length >= 3 || taken[pk[1]]) return;
          return rawProduct(pk[0]).then(function (j) {
            if (!j) return;
            var p = normProduct(j);
            if (taken[p.id]) return;
            if (!p.available) { out.push(null); return; } // sold out: keep its slot for a rule pick
            taken[p.id] = true;
            out.push(p);
          });
        });
      });
      return seq;
    }).then(function () { return out; });
  }

  // Sequential and lazy: stop fetching collections as soon as three categories are filled.
  function pickLook(anchors, cartIds) {
    var taken = {};
    cartIds.forEach(function (id) { taken[id] = true; });
    var picks = [];
    return manualPicks(anchors, taken).then(function (m) {
      picks = m.filter(Boolean);
      var nManual = picks.length;
      var chain = Promise.resolve();
      wantList(anchors, picks.map(function (p) { return p.cat; }).filter(Boolean)).forEach(function (w) {
        chain = chain.then(function () {
          if (picks.length >= 3) return;
          return Promise.all((CAT_COL[w.cat] || []).map(loadCollection)).then(function (lists) {
            var pool = [].concat.apply([], lists);
            var b = bestOf(pool, w, taken);
            if (b) { taken[b.id] = true; picks.push(b); }
          });
        });
      });
      return chain.then(function () {
        // rule picks fill the sold-out slots in place, then the tail
        var extra = picks.slice(nManual);
        var res = [];
        m.forEach(function (p) { if (p) res.push(p); else if (extra.length) res.push(extra.shift()); });
        return res.concat(extra).slice(0, 3);
      });
    });
  }

  function refreshUpsell() {
    var box = document.querySelector('[data-mpx-cart-upsell]');
    if (!box) return;
    plusLabel = box.getAttribute('data-plus') || '';
    var theme = document.querySelector('[data-upsell-products]');
    if (theme && theme.children.length) { box.hidden = true; box.innerHTML = ''; lastSig = null; return; }
    var my = ++token;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) { lastSig = null; box.hidden = true; box.innerHTML = ''; return; }
        var sig = items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
        if (sig === lastSig && box.innerHTML) return;
        var seenH = {};
        var uniq = items.filter(function (i) { return !seenH[i.handle] && (seenH[i.handle] = true); });
        return Promise.all(uniq.map(anchorOf)).then(function (as) {
          return pickLook(as.filter(Boolean), items.map(function (i) { return i.product_id; }));
        }).then(function (list) {
          if (my !== token) return;
          lastSig = sig;
          if (!list.length) { box.hidden = true; box.innerHTML = ''; return; }
          box.innerHTML = '<p class="mpx-cu__h">' + esc(box.getAttribute('data-title')) + '</p>' + list.map(row).join('');
          box.hidden = false;
        });
      })
      .catch(function () {});
  }

  if (typeof module === 'object' && module.exports) module.exports = { anchorOf: anchorOf, pickLook: pickLook, catOf: catOf, MANUAL_SETS: MANUAL_SETS };

  // The theme widget (metafield upsell) wins when it has products; our block only fills the gap.
  var timer;
  var schedule = function () { clearTimeout(timer); timer = setTimeout(refreshUpsell, 150); };
  ['theme:cart:change', 'theme:cart-drawer:open', 'theme:product:added', 'theme:cart:toggle'].forEach(function (n) {
    document.addEventListener(n, schedule);
  });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', schedule); } else { schedule(); }
})();
